"use strict";

require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Footer = void 0;
require("core-js/modules/es.promise.js");
require("core-js/modules/esnext.iterator.constructor.js");
require("core-js/modules/esnext.iterator.map.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _newsletterSender = require("../../utils/clients/newsletterSender");
var _formValidator = require("../../utils/clients/formValidator/formValidator");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const Footer = props => {
  const {
    footerInfo,
    apiUrl
  } = props;
  const [email, setEmail] = (0, _react.useState)("");
  const [formSubmitted, setFormSubmitted] = (0, _react.useState)(false);
  const [isSubmitSuccess, setIsSubmitSuccess] = (0, _react.useState)(false);
  const [submissionErrors, setSubmissionErrors] = (0, _react.useState)(false);
  const website = footerInfo.Website;
  function emailInputHandler(e) {
    setEmail(e.target.value);
  }
  const submitData = async e => {
    e.preventDefault();
    setFormSubmitted(true);
    if (!email || !(0, _formValidator.isValidEmail)(email) || email.length > 50) {
      return;
    }
    if (!website || website.length < 1) {
      return;
    }
    try {
      await (0, _newsletterSender.sendNewsletter)(email, website, apiUrl);
      setIsSubmitSuccess(true);
      setSubmissionErrors(false);
    } catch (error) {
      setSubmissionErrors(true);
    }
  };
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    className: "white-line zoomout-limited"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "con-footer con-text zoomout-limited"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "con-footer__block"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "con-footer__section"
  }, /*#__PURE__*/_react.default.createElement("img", {
    className: "con-footer__logo",
    src: footerInfo.LogoUrl,
    alt: footerInfo.LogoUrl
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "con-footer__section"
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("p", {
    className: "con-text__Xtra-larger-SemiBold con-text__Xtra-larger-SemiBold--no-responsive"
  }, footerInfo.Title), /*#__PURE__*/_react.default.createElement("p", {
    className: "con-text__large-regular con-text__large-regular--gray con-text__large-regular--no-responsive"
  }, footerInfo.Subtitle)), !isSubmitSuccess && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("form", {
    className: "con-footer__form"
  }, /*#__PURE__*/_react.default.createElement("input", {
    type: "email",
    name: "email",
    value: email,
    className: "con-text__medium-regular\n                    ".concat(formSubmitted && !(0, _formValidator.isValidEmail)(email) ? " con-form-group__input--error" : ""),
    onChange: emailInputHandler,
    placeholder: footerInfo.EmailPlaceholder,
    required: true
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "additional-button-border"
  }, /*#__PURE__*/_react.default.createElement("button", {
    type: "submit",
    className: "con-text__large-medium con-centered con-text__button--green",
    onClick: submitData
  }, footerInfo.EmailSubmitButton))), formSubmitted && !(0, _formValidator.isValidEmail)(email) && email || email.length > 50 ? /*#__PURE__*/_react.default.createElement("p", {
    className: "con-error margin-top-10"
  }, footerInfo.NotValidEmailMessage) : "", submissionErrors && /*#__PURE__*/_react.default.createElement("p", {
    className: "con-error"
  }, submissionErrors)), /*#__PURE__*/_react.default.createElement("div", null, !submissionErrors && isSubmitSuccess && /*#__PURE__*/_react.default.createElement("p", {
    className: "con-success"
  }, footerInfo.NewsletterSendMessage)))), /*#__PURE__*/_react.default.createElement("div", {
    className: "con-footer__block"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "con-footer__section con-text__large-regular con-text__large-regular--dark-gray"
  }, /*#__PURE__*/_react.default.createElement("p", null, footerInfo.UnderlineText1), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("a", {
    href: footerInfo.UnderlineText2Url,
    target: "_blank",
    className: "link-styles__2"
  }, footerInfo.UnderlineText2))), /*#__PURE__*/_react.default.createElement("div", {
    className: "con-footer__section"
  }, footerInfo.SocialMedia.map(item => /*#__PURE__*/_react.default.createElement("a", {
    href: item.URL,
    target: "_blank",
    key: item.Name
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "social-icon",
    style: {
      WebkitMaskImage: "url(".concat(item.IconUrl, ")"),
      maskImage: "url(".concat(item.IconUrl, ")")
    },
    "aria-label": item.Name,
    role: "img"
  })))))));
};
exports.Footer = Footer;
Footer.propTypes = {
  footerInfo: _propTypes.default.shape({
    Website: _propTypes.default.string,
    LogoUrl: _propTypes.default.string,
    Title: _propTypes.default.string,
    Subtitle: _propTypes.default.string,
    EmailPlaceholder: _propTypes.default.string,
    EmailSubmitButton: _propTypes.default.string,
    NotValidEmailMessage: _propTypes.default.string,
    NewsletterSendMessage: _propTypes.default.string,
    SubmissionErrorMessage: _propTypes.default.string,
    UnderlineText1: _propTypes.default.string,
    UnderlineText2: _propTypes.default.string,
    UnderlineText2Url: _propTypes.default.string,
    SocialMedia: _propTypes.default.arrayOf(_propTypes.default.shape({
      Name: _propTypes.default.string,
      IconUrl: _propTypes.default.string,
      URL: _propTypes.default.string
    }))
  }),
  apiUrl: _propTypes.default.string
};